import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href", "fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'svgIcon',
  props: {
  //xlink:href属性值前缀
  prefix: {
    type: String,
    default: "#icon-",
  },
  //提供使用的图标名字
  name: String,
  //接受父组件传递颜色
  color: {
    type: String,
    default: "currentColor",
  },
  //接受父组件传递过来的图标的宽度
  width: {
    type: String,
    default: "16px",
  },
  //接受父组件传递过来的图标的高度
  height: {
    type: String,
    default: "16px",
  },
},
  setup(__props) {

//接受父组件传递过来的参数


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    style: _normalizeStyle({ width: __props.width, height: __props.height })
  }, [
    _createElementVNode("use", {
      "xlink:href": __props.prefix + __props.name,
      fill: __props.color
    }, null, 8, _hoisted_1)
  ], 4))
}
}

})